import React, { ComponentProps } from 'react';

import { Box, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

import LuxPlusLogo, { LUXPLUS_LOGO_PLUS_CLASS } from './LuxPlusLogo';

const TierChip = styled(Chip)(({ theme }) => ({
  background: theme.palette.luxPlus.main,
  color: theme.palette.luxPlus.contrastText,
  // Accent the "+" glyph with the brand light-blue, matching the wordmark treatment.
  [`& .${LUXPLUS_LOGO_PLUS_CLASS}`]: {
    fill: theme.palette.luxPlus.light,
  },
}));

type InheritedChipProps = Omit<ComponentProps<typeof Chip>, 'label'>;

interface Props extends InheritedChipProps {
  type: 'default' | 'free-preview';
}

function LuxPlusMembershipChip({ type, ...chipProps }: Props) {
  const label = (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <LuxPlusLogo height={11} />
      {type === 'free-preview' ? 'Free Preview' : 'Member'}
    </Box>
  );

  return <TierChip {...chipProps} label={label} />;
}

export default LuxPlusMembershipChip;
